import axios from 'axios';
import qs from 'qs';
import sha1 from 'crypto-js/sha1';
import Base64 from 'crypto-js/enc-base64';
import { HttpRequest } from './request.utils';
import { baseUrlApis } from './index';
import { URL_ACCOUNT } from './constants';

export default class ThirdPartyApi extends HttpRequest {
  CPDFURI: string;

  constructor() {
    super();
    this.CPDFURI = '';
    this.initialize()
  }
  initialize = () => {
    try {
      baseUrlApis.getBaseUrlBy(URL_ACCOUNT).then((data) => {
        this.CPDFURI = data;
        // 8003 8081
        //this.CPDFURI = 'http://10.103.4.236:8003';
        let axiosClient = axios.create({
          baseURL: this.CPDFURI,
        });
        super.initialize(axiosClient, () => {
          this.interceptorsFn();
        });
        //interceptorsFn(this.apisAxios);
      });
    } catch (error) {
      throw error;
    }
  };
  getAccessToken = async ({type, email, userId, timeStamp, sign}) => {
    // const sign = sha1（固定字符串+邮箱+福昕用户uid+时间戳）
    const requestData = qs.stringify({
      type,
      email,
      userid: userId,
      timestamp: timeStamp,
      sign
    })

    console.log(requestData);
    // if(docList && docList.length !== 0){
    //     data = Object.assign({ documents: docList }, cfg);
    //     allowNoSignIn && Object.assign(data, { sign: md5(`${commonToken}${docList[0].docid}POdfD8JD46DU`).toString() })
    // }else{
    //     data = cfg;
    // }
    

    let url = `/api/users/accessTokenByThirdParty?${requestData}`;
    let result = await this.get({url, config: null, errCallback: null})

    return result;
}
}
